import React from 'react'
import SearchInput from '../../../../../components/common/search-input/SearchInput'
import { SUBMISSION_SEARCH_PARAM } from '../../../../../constants/query-params'

const SubmissionSearch = () => {
    return (
        <SearchInput
            placeholder='Search by submission name or content'
            aria-label='Search by submission name or content'
            searchParam={SUBMISSION_SEARCH_PARAM}
        />
    )
}

export default SubmissionSearch
